module.exports = __webpack_public_path__ + "static/media/Swellow_gaussian2.7fba5aa6.png";